let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7u5Uq"), load("iOr1f")]).then(() => parcelRequire('58rkb'));